import { render, staticRenderFns } from "./LessonCategory.vue?vue&type=template&id=e6b50b2e"
import script from "./LessonCategory.vue?vue&type=script&lang=js"
export * from "./LessonCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports